import {FormikProps} from 'formik';

export const removeWord = (
  selectedWord: {text: string; id: number},
  searchWords: any[],
  formProps: FormikProps<any>,
  fieldName: string
) => {
  const _searchWords = searchWords.filter((word: any) => {
    return word.id !== selectedWord.id;
  });
  formProps.setFieldValue(fieldName, _searchWords);
};
